import {
  NotificationReceiptKey,
  notificationReceiptLoadAdapter,
} from './notification-receipt.adapter';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationReceiptState } from './notification-receipt.reducer';

const getNotificationReceiptsState =
  createFeatureSelector<NotificationReceiptState>(NotificationReceiptKey);

export const getReceiptNotificationCount = createSelector(
  getNotificationReceiptsState,
  ({ count }) => count,
);
export const getReceiptNotificationCountError = createSelector(
  getNotificationReceiptsState,
  ({ countError }) => countError,
);
export const isLoadingCountReceiptNotification = createSelector(
  getNotificationReceiptsState,
  ({ isLoadingCount }) => isLoadingCount,
);

export const getReceiptNotificationMarkAllError = createSelector(
  getNotificationReceiptsState,
  ({ markAllError }) => markAllError,
);
export const isLoadingMarkAllReceiptNotification = createSelector(
  getNotificationReceiptsState,
  ({ isLoadingMarkAll }) => isLoadingMarkAll,
);

export const notificationReceiptSelectors = notificationReceiptLoadAdapter.getSelectors();

export const isOpenMenuNotificationReceipt = createSelector(
  getNotificationReceiptsState,
  ({ isOpen }) => isOpen,
);
